module.exports = __webpack_public_path__ + "media/promo/courses/images/varsm-2418e99d3409f966340f8ffce8daa6f3.png";